<template>
  <button :class="buttonClass" @click="clickHandler">
    <slot />
  </button>
</template>
<script>
export default {
  name: "PromoButton",
  props: {
    theme: {
      type: String,
      default: "primary", // primary, secondary
    },
  },
  computed: {
    buttonClass() {
      return ["promo-button", `promo-button--${this.theme}`];
    },
  },
  methods: {
    clickHandler() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/promo-button";
</style>
